export default "__VITE_ASSET__cc5b24d1__"